import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=60ca2b6c&scoped=true"
import script from "./RadioButtons.vue?vue&type=script&lang=js"
export * from "./RadioButtons.vue?vue&type=script&lang=js"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&id=60ca2b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca2b6c",
  null
  
)

export default component.exports